import { makeStyles, createStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => {
  const { palette } = theme;

  return createStyles({
    body: {
      "& .disabled": {
        opacity: 0.6,
        pointerEvents: "none",
      },
      "& .bold": {
        fontWeight: "bold",
      },
    },
    mainContainer: {
      padding: "5% 3%",
      flex: 1,
      display: "flex",
      flexDirection: "column",
    },
    footerContainer: {
      "& .top-row": {
        marginBottom: "5px",
      },
      paddingBottom: "5px",
      textAlign: "center",
    },
    menu: {
      backgroundColor: palette.primary.main,
      position: "sticky",
      top: 0,
      "& .MuiToolbar-root": {
        justifyContent: "space-between",
        flexDirection: "row",
      },
    },
    menuButton: {
      fontWeight: "bold",
      fontSize: "1.1em",
      textTransform: "uppercase",
    },
    menuItem: {
      "&.Mui-selected": {
        color: palette.primary.main,
        fontWeight: "bold",
      },
      padding: "8px 20px",
    },
    pageHeading: {
      letterSpacing: -0.5,
      marginBottom: "2vh",
      "& .language-list": {
        marginBottom: "5px",
      },
    },
    localeLink: {
      marginRight: "10px",
      cursor: "pointer",
    },
    infoContent: {
      fontSize: "1em",
      "& a": {
        color: theme.palette.secondary.main,
        textDecoration: "none",
      },
      "& img": {
        maxHeight: "200px",
        marginRight: "20px",
      },
    },
    homeWrapper: {
      height: "100%",

      "& .MuiGrid-item": {
        alignItems: "center",
        [theme.breakpoints.up("md")]: {
          display: "flex",
        },
        [theme.breakpoints.down("sm")]: {
          textAlign: "center",
        },
      },
      "& .MuiGrid-item:first-child": {
        position: "relative",
        justifyContent: "center",
      },
      "& h4": {
        fontWeight: 800,
        marginBottom: "30px",
        letterSpacing: -0.5,
        [theme.breakpoints.down("sm")]: {
          marginTop: "3vh",
          fontSize: "2em",
        },
      },
      "& img": {
        webkitFilter: "drop-shadow(0px 10px 30px rgba(0,0,0, .3))",
        filter: "drop-shadow(0px 10px 30px rgba(0,0,0, .3))",
        maxWidth: "100%",
      },
    },
    homeImgDesktopWrapper: {
      height: "100%",
      overflow: "visible",
      maxHeight: "630px",
      position: "relative",

      "& .splash": {
        height: "90%",
        top: "5%",
        marginLeft: "-70%",
        position: "absolute",
      },
      "& .dash": {
        height: "100%",
        position: "relative",
        zIndex: 1,
      },
    },
    googlePlayButton: {
      width: "300px",
      maxWidth: "100%",
      marginTop: "10px",
      "& img": {
        width: "100%",
        filter: "none",
        marginBottom: "30px",
        [theme.breakpoints.up("md")]: {
          marginLeft: "-45px",
        },
      },
    },
  });
});
